import React from "react";
import { Oval } from "react-loader-spinner";

interface SpinningLoaderProps {
  isLoading: boolean;
  hasData: boolean;
}
const SpinningLoader = (props: SpinningLoaderProps) => {
  return (
    <div>
      {props.isLoading && (
        <div className="w-full h-full flex items-center justify-center">
          <Oval
            height="25"
            width="25"
            color="white"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      {!props.isLoading && !props.hasData && (
        <div>
          no records
        </div>
      )}
    </div>
  );
};

export default SpinningLoader;
